import { DatePipe, Location } from "@angular/common";
import { Component, Input, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  CASE_STUDY_GENERATE_DISPLAY_MASTER,
} from "manager/http-constants";
import { AGENDA_SOLUTION_M301_TEMPLATE } from "manager/template-constant";
import { MATCH_TYPE, ROLES } from "src/app/shared/constant/constant";
import { MESSAGE_CODE } from "src/app/shared/constant/message-constant";
import { TOAST } from "src/app/shared/constant/primeng-constants";
import { GENERATE_INPUT_TYPE } from "src/app/shared/generate/generate-input/constant";
import { GenerateInputComponent } from "src/app/shared/generate/generate-input/generate-input.component";
import { DeleteDialogComponent } from "src/app/shared/html-parts/delete-dialog/delete-dialog.component";
import {
  LoadingState,
  LoadData,
} from "src/app/shared/html-parts/loading/loading-state";
import {
  MessageData,
  ToastMessageData,
} from "src/app/shared/html-parts/message-common/message-data";
import { CommonService } from "src/app/shared/service/common.service";
import { DbOperationService } from "src/app/shared/service/db-operation.service";
import { ApprovalDialogComponent } from "../common/approval-dialog/approval-dialog.component";
import { PlatformComponent } from "../platform.component";
import { LoginService } from "src/app/shared/service/login.service";

@Component({
  selector: "app-c361",
  templateUrl: "./c361.component.html",
  styleUrls: ["./c361.component.scss", "../platform.component.scss"],
})
export class C361Component extends PlatformComponent {

  @Input() confirmData: Object;
  @Input() confirmFlag: boolean = false;

  /** 共通部品_承認時ダイアログ */
  @ViewChild(ApprovalDialogComponent)
  approvalDialogComponent: ApprovalDialogComponent;
  /** 新規登録、編集、複製画面 */
  @ViewChild(GenerateInputComponent)
  generateInputComponent: GenerateInputComponent;

  /** 削除ダイアログ */
  @ViewChild(DeleteDialogComponent)
  deleteDialogComponent: DeleteDialogComponent;
  // 課題ID
  agendaId: string = this.route.snapshot.params.case_study_id;

  // 課題・ソリューション詳細格納先
  caseStudy: any;

  // マッチング依頼一覧格納先
  matchingList: any;

  // 質問掲示板の件数格納先
  countQuestionBoard: number = 0;
  class_id: any;
  // variable to show content
  isDataLoaded: boolean = false;
  evaluationList: any[] = [];
  isShowDialogEvaluate: boolean = false;
  matchId: string;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private messageData: MessageData,
    private location: Location,
    public loginService: LoginService
  ) {
    super(route, commonService, dbOperationService, loadingState, loginService);
  }

  public async ngOnInit() {
    // 辞書値リストを取得
    await this.loginService.checkLoginUser()
    this.loginUser = this.loginService.getCurrentUser();

    // ユーザマスタに存在する場合
    this.class_id = this.loginUser?.class_id;
    if (this.confirmFlag) {
      this.isDataLoaded = true;
      this.caseStudy = this.confirmData;
      if (this.caseStudy.icon_image == '') {
        this.caseStudy.icon_image = 'https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/no-image/thumbnail-large/No_Image_Large.jpg'
      }
    } else {
      await this.getDetailTask();
    }
  }


  /**
   * 課題・ソリューション詳細を取得
   */
  public getDetailTask() {
    const endpoint = CASE_STUDY_GENERATE_DISPLAY_MASTER;
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(endpoint);

    return new Promise<any>((resolve) => {
      this.dbOperationService
        .getNoTemplateDisplayData(
          CASE_STUDY_GENERATE_DISPLAY_MASTER,
          this.agendaId,
          false
        )
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, endpoint);

          if (this.commonService.checkInvalidValue(response)) {
            this.isDataLoaded = false;
            // 警告メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.WARN,
                summary: this.commonService.msg(MESSAGE_CODE.E00003),
                detail: this.commonService.msg(MESSAGE_CODE.E00026),
              })
            );

            // 前画面へ戻る
            this.location.back();
          } else {
            this.isDataLoaded = true;
            // 課題・ソリューション詳細を格納
            this.caseStudy = response.body;

          }
          resolve(null);
        });
    });
  }

  /**
   * 再検索処理＆データ置換
   * @param pkeyId コード値
   */
  public searchReplacement(pkeyId: string) {
    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.customLoadStart(
      new LoadData({
        loadingText: this.commonService.msg(MESSAGE_CODE.S00004),
      })
    );

    // 検索処理を実施
    this.getDetailTask();

    // 画面ロードフラグをOFF(ロード終了)
    this.loadingState.loadSleepEnd(0.3);
  }

  moveC261() {
    this.router.navigate(["pages/platform/c261/"])
  }

  /**
   * check overflow of element
   * @param el html element of list
   * @returns
   */
  isOverflow(el: HTMLElement): boolean {
    const curOverflow = el.style.overflow;
    if (!curOverflow || curOverflow === "visible") el.style.overflow = "hidden";
    const isOverflowing =
      el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;
    el.style.overflow = curOverflow;
    return isOverflowing;
  }

  back() {
    if (this.loginUser?.class_id == ROLES.ADMIN) {
      this.router.navigate(["pages/platform/master/m601"]);
    } else {
      this.location.back();
    }
  }
}
